import { calculatePickemWinner } from '../rules/winnerRules';

export function enterTiebreaker({ winners, week, value, cards, matchups, currentWeek }) {
  if (!Number.isInteger(week) || week < 1 || week >= currentWeek) throw new Error('Only completed weeks can be settled.');
  if (String(value ?? '').trim() === '' || !Number.isFinite(Number(value))) throw new Error('Enter a valid tiebreaker number.');
  const old = winners[week]?.data;
  if (old?.tiebreaker !== '' && old?.tiebreaker != null) throw new Error('This week already has a tiebreaker. Refresh to see its results.');
  const pairs = (matchups || []).filter(p => p?.length === 2);
  const ids = old?.picks || [];
  if (!ids.length) throw new Error('Wait for all matchup results before entering the tiebreaker.');
  if (pairs.length && (ids.length !== pairs.length || !pairs.every(pair => pair.filter(t => ids.includes(t[0])).length === 1))) {
    throw new Error('Wait for all matchup results before entering the tiebreaker.');
  }
  const winner = calculatePickemWinner(cards.filter(c => Number(c.Week) === week), ids, pairs.length || ids.length, value);
  const next = [...winners];
  next[week] = { ...winners[week], data: { ...old, tiebreaker:String(Number(value)), winner_info:winner || ['',0] } };
  return next;
}
